import { createAkiliApi } from '../../utils/api/api-methods'

type Data = {
  firstName: string
  lastName: string
  zipcode: string
  phone?: string
}

type RequestData = {
  given_name: string
  family_name: string
  zip_code: string
  phone_number?: string
}

/*
  400	- bad request errors / request validation error
  401	- unauthorized
*/

type ErrorResponse = {
  success: false
  status: 400 | 401
  localizedErrorMessage: string
  requestParams: RequestData
  responsePayload: {
    message: string
    description: string
  }
}

type SuccessResponse = {
  success: true
  status: 200
  requestParams: RequestData
}

const name = 'updateCaregiver'

const updateCaregiverApi = (
  authToken: string,
  caregiverId: string,
  data: Data
): Promise<ErrorResponse | SuccessResponse> => {
  const url = `/caregivers/${caregiverId}`

  const payload = {
    given_name: data.firstName,
    family_name: data.lastName,
    zip_code: data.zipcode
  } as RequestData

  if (data.phone && data.phone !== '') {
    payload.phone_number = data.phone
  }

  return createAkiliApi(authToken, url, 'PATCH', name, payload)
}

export default updateCaregiverApi
